<script lang="ts">
  import { materialColors } from '../../constants/theme'

  type Props = {
    color?: string
    onColorChange?: (color: string) => void
  }
  let { color, onColorChange }: Props = $props()

  let isPickerOpened = $state(false)

  const handleColorChange = (newColor: string) => {
    onColorChange?.(newColor)
    isPickerOpened = false
  }
</script>

<div class="color-picker">
  <button
    style:background={`var(--color-picker-${color})`}
    class="selected-color"
    aria-label={color}
    onclick={() => (isPickerOpened = !isPickerOpened)}
  ></button>
  {#if isPickerOpened}
    <div class="picker-container">
      {#each materialColors as color (color)}
        <button
          style:background={`var(--color-picker-${color})`}
          class="color"
          aria-label={color}
          onclick={() => handleColorChange(color)}
        ></button>
      {/each}
    </div>
  {/if}
</div>

<style lang="scss">
  .color-picker {
    position: relative;
    display: flex;

    .selected-color {
      border: 0;
      border-radius: 0.125rem;
      cursor: pointer;
      width: 1rem;
      height: 1rem;
      min-width: 1rem;
      min-height: 1rem;

      &:focus-visible {
        outline: 1px solid var(--stroke);
        outline-offset: 2px;
      }
    }

    .picker-container {
      border-radius: 0.25rem;
      display: grid;
      background: var(--context-menu-background);
      gap: 0.75rem;
      grid-template-columns: repeat(6, 1fr);
      position: absolute;
      padding: 0.75rem 0.5rem;
      top: 1.5rem;
      left: -0.5rem;
      width: fit-content;
      z-index: 99;

      &::before {
        content: "";
        border-bottom: 0.25rem solid var(--context-menu-background);
        border-left: 0.25rem solid transparent;
        border-right: 0.25rem solid transparent;
        position: absolute;
        top: -0.25rem;
        left: 0.75rem;
      }

      .color {
        border: 0;
        cursor: pointer;
        min-width: 1rem;
        min-height: 1rem;
        width: 1rem;
        height: 1rem;
        border-radius: 0.125rem;
      }
    }
  }
</style>
